import { getAxiosClient } from "../../axios-client";
import {
  OfferClientFinalAcceptNotificationRequestBody,
  OfferClientFinalAcceptNotificationResponse,
} from "./types";

const axiosClient = getAxiosClient();
export const offerClientFinalAcceptNotification = async (
  body: OfferClientFinalAcceptNotificationRequestBody
) => {
  return await axiosClient.ax.post<OfferClientFinalAcceptNotificationResponse>(
    "/Offers/OfferClientFinalAcceptNotification",
    body
  );
};
